// AdminWelcome — Day 13 D16: kept as a route but auto-redirects to /audio
// on mount. Workers don't need a "你是誰" page after Google sign-in; the
// AdminGate has already filtered, AdminNav shows email constantly.

import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

export function Welcome() {
  const nav = useNavigate();
  useEffect(() => {
    nav("/audio", { replace: true });
  }, [nav]);
  // Fallback in case effect doesn't fire (SSR / hydration edge)
  return <Navigate to="/audio" replace />;
}
